import React from 'react';
import { IBasicLookupFieldProps } from '@markinson/uicomponents-v2/BasicLookupField';
import { IBasicLookupFieldHandle } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';
import ProductLookup from 'components/common/ProductLookup';
interface IScopeOptions {
  isCustomerScoped?: boolean;
  isWarehouseScoped?: boolean;
}

export interface IProductLookupFieldProps extends Omit<IBasicLookupFieldProps, 'valueField' | 'displayField' | 'descriptionField' | 'column1Field' | 'column2Field'>, IScopeOptions {
  params?: any;
  fieldRef?: React.Ref<IBasicLookupFieldHandle>;
  onValueChange?(value: string): void;
  onTypingValueChange?(value: string): void;
  setFieldAsyncError?(fieldName: string, error: string): void;
}

const ProductLookupField = (props: Omit<IProductLookupFieldProps, 'classes' | 'onFindOption' | 'onSearch'>, ref: React.Ref<IBasicLookupFieldHandle>) => {

  const {
    fieldRef,
    params = {},
    isCustomerScoped = false,
    isWarehouseScoped = false,
    setFieldAsyncError,
    onSelectedItemChange,
    onChange,
    onValueChange,
    onTypingValueChange,
    onInvalidChange,
  } = props;

  return (
    <ProductLookup
      {...props}
      ref={fieldRef ? fieldRef : ref}
      Warehouse={isWarehouseScoped ? params?.Warehouse : undefined}
      CustomerId={isCustomerScoped ? params?.CustomerId : undefined}
      onSelectedItemChange={(selectedItem: any, searchText) => {
        const productId = selectedItem?.Details?.ProductId ? Number(selectedItem?.Details?.ProductId) : selectedItem?.Code;

        if (onChange) {
          const { disableOptionsLookup, suppressValidation } = props || {};
          const selectedValue = !!(disableOptionsLookup && suppressValidation) ? searchText : productId;

          onChange(selectedValue || '');
        }

        if (onSelectedItemChange) {
          onSelectedItemChange(selectedItem, searchText);
        }
      }}
      onInvalidChange={(invalid: boolean, invalidValue) => {
        if (onInvalidChange) {
          onInvalidChange(invalid, invalidValue);
        }
        if (setFieldAsyncError) {
          setFieldAsyncError(props.name, invalid ? 'Invalid Value' : null);
        }
      }}
      onChange={onValueChange}
      onValueChange={onTypingValueChange}
    />
  );
};

export default React.memo(React.forwardRef(ProductLookupField));
